import { reactive, toRefs } from 'vue';

let store;

export function useMainStore() {
  if (store) return store;

  const state = reactive({
    appBaseUrl: '/mms_internal',
    from: null,
    fullPathesRouteHistory: [],
    isCustomerPortal: false,
    to: null,
  });

  function cachePrevFullPath() {
    if (state.to?.fullPath) {
      state.fullPathesRouteHistory.push(state.to.fullPath);
    }
  }

  function removePrevFullPath() {
    state.fullPathesRouteHistory.pop();
  }

  function setFromTo(to, from) {
    state.to = to;
    state.from = from;
  }

  store = {
    ...toRefs(state),
    cachePrevFullPath,
    removePrevFullPath,
    setFromTo,
  };

  return store;
}
